/**
 * Constants - константы приложения
 */

// Статусы персонажей
export const CHARACTER_STATUS = {
    ACTIVE: 1,
    BANNED: 2,
    DELETED: 3,
    PENDING: 4,
};

export const CHARACTER_STATUS_LABELS = {
    [CHARACTER_STATUS.ACTIVE]: "Активен",
    [CHARACTER_STATUS.BANNED]: "Заблокирован",
    [CHARACTER_STATUS.DELETED]: "Удалён",
    [CHARACTER_STATUS.PENDING]: "На рассмотрении",
};

// Регистрация
export const REGISTRATION = {
    MIN_QUESTIONS: 10,
    MIN_CORRECT_ANSWERS: 7,
    CODE_LENGTH: 6,
    CODE_EXPIRY: 300, // 5 минут
};

// Валидация
export const VALIDATION = {
    LOGIN_MIN_LENGTH: 3,
    LOGIN_MAX_LENGTH: 20,
    PASSWORD_MIN_LENGTH: 6,
    PASSWORD_MAX_LENGTH: 50,
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    LOGIN_REGEX: /^[a-zA-Z0-9]+$/,
};

// Пагинация
export const PAGINATION = {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 20,
    MAX_LIMIT: 100,
};

// Тайминги
export const TIMINGS = {
    TOAST_DURATION: 3000,
    MODAL_TRANSITION: 300,
    DEBOUNCE_DELAY: 300,
    THROTTLE_DELAY: 100,
};

// Storage keys
export const STORAGE_KEYS = {
    TOKEN: "jwtToken",
    USER_ID: "user-id",
    USER_LOGIN: "user-login",
    USER_PASSWORD: "user-password",
    USER_EMAIL: "user-email",
    SETTINGS: "user-settings",
};

// API
export const API = {
    BASE_URL: "api/",
    TIMEOUT: 30000,
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000,
};
